import React, { useState, useEffect } from 'react'
import { View, ScrollView, Image, Platform, Text, StyleSheet, Linking, ActivityIndicator } from 'react-native'
import { useDispatch, useSelector } from 'react-redux'
import Header from '../../components/Header'
import { CaptionNormalDark, BodyNormalDark, CaptionBoldDark, SubheaderNormalDark, ProgressBar, ComponentSeeAll } from '../../components'
import DoughnutChart from '../../components/DoughnutChart'
import * as Actions from '../../action'
import styles from '../../styles'
import { global, colors } from '../../const'
import ProfileList from '../../components/profile/ProfileList'
import Button from '../../components/form/Button'
import localize from '../../localize'

function TeamContainer (props) {
  const dispatch = useDispatch()
  const height = useSelector(({ setting }) => setting.height)
  const [state, setState] = useState({
    id: null,
    name: null,
    kind: null,
    progress: [],
    members: [],
    team: []
  })

  useEffect(() => {
    let data
    if (!global.isNative) {
      const query = new URLSearchParams(props.location.search)
      data = props.location.state
      if (!data) data = { id: query.get('id'), name: query.get('name') }
    } else {
      data = props.navigation.state.params
    }
    _teamInfo(data)
  }, [global.isNative ? props.navigation.state.params : props.location.state])

  const _teamInfo = async (team) => {
    const response = await dispatch(Actions.getStranth('', '', team.id))
    if (response[0]) {
      const membersStr = JSON.stringify(response[0].member_ids).slice(1, -1)
      const members = await dispatch(Actions.getWcUsersInfo(membersStr.replace(new RegExp('"', 'g'), '')))
      setState({ ...state, members, progress: response[0], team })
    }
  }

  const _navigation = (pathname, state, search) => {
    if (global.isNative) return props.navigation.navigate(pathname, state)
    props.history.push({
      pathname, state, search
    })
  }

  const openApp = () => {
    if (Platform.OS === 'web') return window.open('https://www.woogicreate.com', '_blank')
    const appstore = 'https://apps.apple.com/us/app/woogi-create/id1121554942'
    const iosSchema = 'woogicreate://'

    const playstore = 'https://play.google.com/store/apps/details?id=com.WoogiWorld.WoogiCreate&hl=en'
    const androidSchema = 'woogicreate://'

    Linking.canOpenURL(Platform.select({ ios: iosSchema, android: androidSchema }))
      .then((supported) => {
        if (!supported) {
          return Linking.openURL(Platform.select({ ios: appstore, android: playstore }))
        } else {
          return Linking.openURL(Platform.select({ ios: iosSchema, android: androidSchema }))
        }
      })
      .catch((err) => Linking.openURL(Platform.select({ ios: appstore, android: playstore })))
  }

  const { progress, members, team } = state

  return (
    <View style={styles.container}>
      {!global.isNative && (<Header title={localize.Village_Team} goBack={() => props.history.goBack()} />)}

      <ScrollView style={!global.isNative && { height: height - 70 }}>
        <View>
          <View style={pageStyles.divider} />
          <View style={pageStyles.pageHeading}>
              <View style={{ alignItems: 'center' }}>
              <CaptionNormalDark title={localize.Village} />
              <BodyNormalDark title={team.name} />
            </View>
            </View>
          <View style={pageStyles.divider} />
        </View>

        <View style={pageStyles.rowCenter}>
          <View style={pageStyles.buttonArea}>
              <Button
              title={localize.Go_To_Village}
              size='small'
              onPress={openApp}
            />
            </View>
          <Text style={pageStyles.buttonSubTitle}>{localize.Opens_in_Woogi_Create_App}</Text>
        </View>

        <View style={pageStyles.divider} />

        <View style={pageStyles.progressArea}>

          <View style={pageStyles.progressHeading}>
              <SubheaderNormalDark title={localize.Team_Strength} />
              <ComponentSeeAll
              onClick={() => _navigation(Platform.select({ web: '/dashboard/progress', default: 'progress' }), { type: team.kind, id: team.id }, `type=${team.kind}&id=${team.id}`)}
            />
            </View>

          <ProgressBar
              progress={(progress.strength) / 10 + '%'}
              start={team.kind === 2 ? localize.GOLD : localize.Brass}
              end={team.kind === 2 ? localize.ZIRCONIUM : localize.Iron}
            />

        </View>

        <View style={pageStyles.divider} />

        <View style={pageStyles.progressChart}>
          <DoughnutChart
              data={progress}
              title={localize.team_xp}
            />
        </View>

        <View style={pageStyles.progressChart}>

          <View style={pageStyles.dontChartRow}>

              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <View style={[pageStyles.chartColorLable, { backgroundColor: '#00c221' }]} />
              <CaptionBoldDark title={localize.character} />
            </View>

              <CaptionNormalDark title={progress.character} />

            </View>

          <View style={pageStyles.dontChartRow}>

              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <View style={[pageStyles.chartColorLable, { backgroundColor: '#5e23ff' }]} />
              <CaptionBoldDark title={localize.life_experience} />
            </View>
              <CaptionNormalDark title={progress.life_experience} />

            </View>

          <View style={pageStyles.dontChartRow}>

              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <View style={[pageStyles.chartColorLable, { backgroundColor: '#ffd000' }]} />
              <CaptionBoldDark title={localize.financial} />
            </View>

              <CaptionNormalDark title={progress.financial} />

            </View>

          <View style={pageStyles.dontChartRow}>

              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <View style={[pageStyles.chartColorLable, { backgroundColor: '#ff0048' }]} />
              <CaptionBoldDark title={localize.health_wellness} />
            </View>

              <CaptionNormalDark title={progress.health} />
            </View>
        </View>

        <View style={pageStyles.divider} />

        <View style={pageStyles.memberHeader}>
          <Text style={pageStyles.memberTitle}>
              {localize.Village_Members}
            </Text>
          {!members || members.length <= 0 && (<ActivityIndicator size={18} style={{ marginLeft: 10 }} />)}
        </View>

        {members.map((item, i) => <ProfileList data={item} type='user' props={props} key={i} />)}
      </ScrollView>
    </View>
  )
}

TeamContainer.navigationOptions = () => {
  return {
    title: localize.Village_Team
  }
}

export default TeamContainer

const pageStyles = StyleSheet.create({
  buttonSubTitle: {
    fontStyle: 'italic',
    color: colors.midnightBack,
    fontSize: 16,
    textAlign: 'center',
    paddingTop: 12,
    paddingBottom: 20
  },
  buttonArea: {
    width: '60%',
    paddingTop: 20
  },
  rowCenter: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  divider: {
    height: 1,
    backgroundColor: colors.lightGray,
    width: '100%'
  },
  pageHeading: {
    justifyContent: 'center',
    padding: 10,
    backgroundColor: colors.white
  },
  progressArea: {
    backgroundColor: colors.white,
    padding: 20
  },
  progressHeading: {
    paddingBottom: 15,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row'
  },
  progressChart: {
    paddingVertical: 20,
    backgroundColor: colors.white
  },
  dontChartRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingRight: 50,
    paddingTop: 15,
    paddingHorizontal: 30
  },
  chartColorLable: {
    height: 12,
    width: 18,
    borderRadius: 4,
    marginRight: 6
  },
  memberHeader: {
    paddingVertical: 15,
    paddingLeft: 15,
    flexDirection: 'row',
    alignItems: 'center'
  },
  memberTitle: {
    fontFamily: global.FONT_REGULAR,
    fontSize: 20,
    fontWeight: '500',
    color: colors.midnightBack
  },
  modal: {
    width: '100%',
    alignItems: 'center'
  },
  modalTitle: {
    color: colors.midnightBack,
    fontFamily: global.FONT_REGULAR,
    fontSize: 18,
    textAlign: 'center'
  },
  modalIcon: {
    height: 50,
    width: 50,
    backgroundColor: colors.green,
    borderRadius: 50 / 2,
    marginBottom: 15,
    marginTop: 30,
    justifyContent: 'center',
    alignItems: 'center'
  },
  modalImageIcon: {
    width: '60%',
    height: '60%'
  }

})
